import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticationsGuard } from './_guard/auth-guard';
import { LoginAuthGuardGuard } from './_guard/login-auth-guard.guard';
import { StudentsAuthGuardGuard } from './_guard/students-auth-guard.guard';
import { BlankComponent } from './_layouts/blank/component/blank.component';
import { MainComponent } from './_layouts/main/component/main.component';

const routes: Routes = [
  {
    path: 'Home',
    component: MainComponent,
    canActivate: [AuthenticationsGuard],
    loadChildren: './_layouts/main/module/main.module#MainModule',
    data: {
      breadcrumb: 'Home',
      visable: false
    }
  },
  {
    path: 'students',
    canActivate: [StudentsAuthGuardGuard],
    loadChildren: './pages/students-portal/students.module#StudentsModule',
    data: {
      breadcrumb: 'Student',
      visable: false
    }
  },
  {
    path: 'Login',
    component: BlankComponent,
    canActivate: [LoginAuthGuardGuard],
    loadChildren: './pages/login/login.module#LoginModule',
    data: { breadcrumb: 'Login' }
  },
  {
    path: '**',
    redirectTo: 'Login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: []
})
export class AppRoutingModule {}
